import $ from "jquery";

let webinarDate = $(".hidden.date").text().trim();
let webinarStartTime = $(".hidden.time-start").text().trim();
let webinarEndTime = $(".hidden.time-end").text().trim();
let webinarLink = $(".hidden.link").text().trim();
let timeToShow = $(".hidden.time-to-show").text().trim();
let dateToShow = $(".hidden.date-to-show").text().trim();
let webinarTitle = $(".title h1").text().trim();

localStorage.setItem("webinarLink", webinarLink);
localStorage.setItem("webinarStartTime", webinarStartTime);
localStorage.setItem("webinarEndTime", webinarEndTime);
localStorage.setItem("webinarDate", webinarDate);
localStorage.setItem("webinarTitle", webinarTitle);
localStorage.setItem("timeToShow", timeToShow);
localStorage.setItem("dateToShow", dateToShow);
if (dateToShow) {
  window.addEventListener("message", (event) => {
    if (
      event.data.type === "hsFormCallback" &&
      event.data.eventName === "onFormSubmitted"
    ) {
      window.location.href = `/thank-you-for-registering/`;
    }
  });
}

